import React, { useState, useEffect } from 'react';

import _service from '@netuno/service-client';

import { Button, Table, notification, Popconfirm, Space } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import ToProduceModal from './Modal';
import CalcModal from '../CalcModal/ToProduceCalc'

import config from '../../../../../config/config.json';

import './index.less';

const langContext = 'reserved-area.construction'

export default ({ construction_uid }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalUID, setModalUID] = useState(null);
  const [isCalcModalVisible, setCalcModalVisible] = useState(false);
  const [modalData, setCalcModalData] = useState(null);
  const [calcModalUID, setCalcModalUID] = useState(null)
  useEffect(() => {
    onLoadData();
  }, []);

  const intl = useIntl();

  const onEditModal = (data) => {
    setIsModalVisible(true);
    setModalUID(data.uid);
  };

  const onShowModal = () => {
    setIsModalVisible(true);
    setModalUID(null);
  };

  const onModalClose = (data) => {
    setIsModalVisible(false);
  };

  const onLoadTable = () => {
    onLoadData();
  };
  
  const openCalcModal = (data) => {
    setCalcModalVisible(true);
    setCalcModalData(data);
    setCalcModalUID(data.uid)
  }

  const onCalcModalClose = () => {
    setCalcModalVisible(false)
    setModalUID(null)
  }

  function onLoadData() {
    setLoading(true);
    _service({
      method: 'GET',
      url: '/construction/waste/produce/list',
      data: {
        construction_uid
      },
      success: (response) => {
        setLoading(false);
        setData(response.json);
      },
      fail: (e) => {
        notification["error"]({
          message: 'Erro no carregamento dos dados dos Resíduos a produzir',
          description: e.response.json.error,
        });
      }
    });
  }

  function onDeleteWaste(uid) {
    setLoading(true);
    _service({
      method: 'DELETE',
      url: '/construction/waste/produce',
      data: { uid: uid },
      success: (response) => {
        if (response.json.result) {
          const newData = data.filter(elem => elem.uid);
          setData(newData);
          setLoading(false);
          notification["success"]({
            message: 'Resíduo removido com sucesso',
          });
          onLoadTable();
        }
      },
      fail: (e) => {
        setLoading(false);
        notification["error"]({
          message: 'Não foi possivel apagar o residuo.',
          description: e.response.json.error,
        });
      }
    });
  }

  const columns = [
    {
      title: intl.formatMessage({ id: langContext + '.waste.to-produce.title' }),
      dataIndex: 'waste_type',
      key: 'description',
      render: data => data.description[intl.locale.split('-')[0]]
    },
    {
      title: intl.formatMessage({ id: langContext + '.fields.amount' }),
      dataIndex: 'amount',
      key: 'amount',
      render: (record) => record.toString().replace(/(\d)(\d{2})$/, "$1,$2")
    },
    {
      title: intl.formatMessage({ id: 'components.measurement-unit-select.title' }),
      dataIndex: 'measurement_unit',
      key: 'description',
      render: data => data.description[intl.locale.split('-')[0]]
    },
    {
      title: intl.formatMessage({ id: langContext + '.fields.photo' }),
      key: 'photo',
      render: data => {
        if (data.photo) {
          return <img src={config.api.services + 'construction/waste/produce/photo?uid=' + data.uid + '&type=mini'} />;
        } else {
          return null;
        }
      }
    },
    {
      title: intl.formatMessage({ id: langContext + '.fields.action' }),
      key: 'edit',
      width: '5%',
      render: data =>
        <Space className="button-actions">
          <Button title="Ver no Marketplace"
            type="primary"
            onClick={() => openCalcModal(data)}>
            <FormattedMessage id={`${langContext}.button.see-marketplace`}/>
          </Button>
          <div style={{ display: 'flex', width: '100%'}}>
          <Button
            title="Editar"
            className="edit-row"
            onClick={() => onEditModal(data)}>
            <FormattedMessage id={`${langContext}.button.edit`} />
          </Button>
          <Popconfirm
            title="Tem a certeza que quer apagar o residuo a produzir?"
            onConfirm={() => onDeleteWaste(data.uid)}
            okText="Sim"
            cancelText="Não"
          >
            <Button danger
              type='text'
              title='Apagar'><FormattedMessage id={`${langContext}.button.delete`} />
            </Button>
          </Popconfirm>
          </div>
        </Space>
    }
  ];

  return (
    <div>
      <div>
        <Table
          loading={loading}
          dataSource={data}
          columns={columns}
        />
        <Button type="primary" onClick={onShowModal}>
          <FormattedMessage id={`${langContext}.button.create`} />
        </Button>
      </div>
      {isModalVisible && <ToProduceModal construction_uid={construction_uid} uid={modalUID} onClose={onModalClose} onLoad={onLoadTable} />}
      {isCalcModalVisible && <CalcModal onClose={onCalcModalClose} construction_uid={construction_uid} uid={calcModalUID} data={data}/>}
    </div>
  );
}
